module.exports = __webpack_public_path__ + "media/aerial-farm-hd04.64e3c086.mp4";